import AppConstants from '../config/app.constants';

let BranchFundingSourceService = function ($http, $q) {

    let all = (search, offset, limit, customerId) => {
        return $http
            .get(AppConstants.api + `/branch-funding-source`, {
                params: {
                    search,
                    offset,
                    limit,
                    customerId
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/branch-funding-source/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        let query = '';
        if (id) {
            query = `?branchFundingSourceId=${id}`
        }
        return $http
            .get(AppConstants.api + `/branch-funding-source/getBranchFunding` + query)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/branch-funding-source/${id}/update`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/branch-funding-source/delete-funding-source`, {
                params: {
                    id,
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let fundingSourceLocation = (locationId, searchText, branchId, limit, offset) => {
        return $http
            .post(AppConstants.api + `/branch-funding-source/funding-source-location`, {
                locationId,
                searchText,
                branchId,
                limit,
                offset
            })
            .then((res) => {
                return res.data
            })
    }

    let getFundingSourceHolidayCount = (branchFundingSourceId, startDate, endDate) => {
        return $http
            .get(AppConstants.api + `/branch-funding-source/${branchFundingSourceId}/funding-source-holiday-count`, {
                params: {
                    branchFundingSourceId,
                    startDate,
                    endDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getDenominations = () => {
        return $http
            .get(AppConstants.api + `/branch-funding-source/get-denominations`)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        get,
        update,
        remove,
        fundingSourceLocation,
        getFundingSourceHolidayCount,
        getDenominations
    };

};

BranchFundingSourceService.$inject = ['$http', '$q']

export default BranchFundingSourceService;


// WEBPACK FOOTER //
// ./client/app/services/branch-funding-source.service.js